module.exports = __webpack_public_path__ + "img/custom-item2-4.27bf1f5.png";